import { axiosGet, axiosPost } from "./axiosFunctions";
import { getAuthState } from "../../assets/scripts/login-util";

const getTPAUrl      = '/api/admin/tpa/getTPA';
const postTPAUrl     = '/api/admin/tpa/postTPA';

export const getTPAList = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( getTPAUrl, { headers: { auth_token: `bearer ${token}` }} );
    return response;
}

export const postTPA = async (tpa) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosPost(
        postTPAUrl,
        { tpa },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};